const Routes = {
  ADHD_CARE_JOURNEY: '/adhd-care-journey',
  ADHD_CARE_UPLOAD_MEDICAL_RECORDS: '/adhd-care-journey/upload-medical-records',
  APPOINTMENTS: '/appointments',
  APPOINTMENT_QUESTIONNAIRES: (id: string) =>
    `/appointments/${id}/questionnaires`,
  AVAILABILITIES: '/availabilities',
  BILLING: '/billing',
  CHECKOUT: '/checkout',
  CLINICAL_SUMMARY: (id: string) => `/appointments/${id}/summary`,
  HOME: '/homepage',
  INSURANCE: (id: string) => `/insurance/${id}`,
  INVOICE: (id: string) => `/invoices/${id}`,
  LAB_REPORT: (id: string) => `/lab-reports/${id}`,
  LAB_REPORTS: '/lab-reports',
  LOGIN: '/login',
  PAYMENT: '/payment',
  PHARMACIES: '/pharmacies',
  PRESCRIPTION: (id: string) => `/prescriptions/${id}`,
  PRESCRIPTIONS: '/prescriptions',
  PRODUCT: (id: string) => `/products/${id}`,
  PRODUCTS: '/products',
  ZIPCODE: '/zipcode',
  PROFILE: '/profile',
  QUESTIONNAIRE_RESPONSE: (id: string) => `/questionnaire-responses/${id}`,
  QUESTIONNAIRE_RESPONSES: '/questionnaire-responses',
  RECORDS: '/records',
  SECURE_CARE_INBOX: '/conversations',
  SIGN_OUT: '/sign-out',
  ZOCDOC_ACTIVATE_ACCOUNT: '/zocdoc/activate-account',
  MEDICAL_RECORDS: '/medical-records',
  MEDICAL_RECORDS_ADD_OR_REQUEST: '/medical-records/add-or-request',
  MEDICAL_RECORDS_REQUEST: '/medical-records/request',
  MEDICAL_RECORDS_ADD: '/medical-records/add',
  MEDICAL_RECORDS_ADD_CATEGORY: (category: string) =>
    `/medical-records/add/${category}`,
  MEDICAL_RECORDS_ADD_CATEGORY_NEW: (category: string) =>
    `/medical-records/add/${category}/new`,
} as const

export default Routes

export const MOBILE_APP_BILLING_URL = 'https://app.circlemedical.com/billing'

function routeMatches(
  route: string,
  matchingRoute: string | ((id: string) => string),
) {
  if (typeof matchingRoute === 'string') {
    return route.includes(matchingRoute)
  }

  const baseRoute = matchingRoute('')
  return route.includes(baseRoute)
}

function routeBelongsToCategory(
  route: string,
  matchingRoutes: Array<string | ((id: string) => string)>,
) {
  return matchingRoutes.some((matchingRoute) =>
    routeMatches(route, matchingRoute),
  )
}

export function routeBelongsToRecordsPage(route: string) {
  const recordsRoutes = [
    Routes.PRESCRIPTIONS,
    Routes.LAB_REPORTS,
    Routes.QUESTIONNAIRE_RESPONSES,
  ]
  return recordsRoutes.some((recordRoute) => route.includes(recordRoute))
}

export function isBookingFlowRoute(route: string) {
  const bookingFlowRoutes = [
    Routes.PRODUCTS,
    Routes.PAYMENT,
    Routes.AVAILABILITIES,
    Routes.CHECKOUT,
    Routes.ZIPCODE,
  ]

  return bookingFlowRoutes.some((bookingFlowRoute) =>
    route.includes(bookingFlowRoute),
  )
}

const BILLING_ROUTES = [Routes.INVOICE, Routes.INSURANCE]

export function routeBelongsToBillingPage(route: string) {
  return routeBelongsToCategory(route, BILLING_ROUTES)
}
